import styled from 'styled-components';
import { getRelativeHeight } from '../../components/CardReader/CardReader';
import { TABLET_BREAKPOINT_IN_PX } from '../../constants';

const ZoneButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: start;
  margin-left: 23%;

  @media screen and (max-width: ${TABLET_BREAKPOINT_IN_PX}px) {
    margin-bottom: ${getRelativeHeight(6)};
  }

  & > a {
    margin-bottom: ${getRelativeHeight(3)};

    &:last-child {
      margin-bottom: ${getRelativeHeight(27)};
    }
  }
`;

export default ZoneButtonsWrapper;
